import { format, isValid } from "date-fns";

import { AssignedTag } from "services/types/assigned-tag.type";

export const getAssignedTagTooltip = (
  assignedTag: AssignedTag,
  isTagExpired: boolean
) => {
  const { tag, description, expires_at } = assignedTag;
  const parsedDate = expires_at ? new Date(expires_at) : null;
  const formattedExpiredDate =
    parsedDate && isValid(parsedDate) ? format(parsedDate, "MM/dd/yyyy") : "";

  const parts: string[] = [];

  if (description) {
    parts.push(description);
  }

  if (tag.tooltip) {
    const tooltipText = description ? `(${tag.tooltip})` : tag.tooltip;
    parts.push(tooltipText);
  }

  if (expires_at && formattedExpiredDate) {
    const expiredText = isTagExpired
      ? `expired on ${formattedExpiredDate}`
      : `until ${formattedExpiredDate}`;
    const prefix = parts.length > 0 ? "- " : "";
    parts.push(`${prefix}${expiredText}`);
  }

  return parts.join(" ");
};
